import Login from './pages/Login.svelte';
import Account from './pages/Account.svelte';
import AdminUsers from './pages/admin/Users.svelte';

import AgentsCart from './pages/agents/Cart.svelte';
import AgentsCarts from './pages/agents/Carts.svelte';
import AgentsProducts from './pages/agents/Products.svelte';
import AgentsOrders from './pages/agents/Orders.svelte';
import AgentsReturns from './pages/agents/Returns.svelte';
import AgentsReturnNotes from './pages/agents/ReturnNotes.svelte';
import AgentsReturnNoteNew from './pages/agents/ReturnNoteNew.svelte';
import AgentsReturnNote from './pages/agents/ReturnNote.svelte';

const mainRoutes = {
    '/agents/carts' : AgentsCarts,
    '/agents/carts/:cart_id' : AgentsCart,
    '/agents/products' : AgentsProducts,
    '/agents/products/:cart_id' : AgentsProducts,
    '/agents/orders' : AgentsOrders,
    '/agents/returns' : AgentsReturns,
    '/agents/return-notes' : AgentsReturnNotes,
    '/agents/return-notes/new' : AgentsReturnNoteNew,
    '/agents/return-notes/:id' : AgentsReturnNote,

    '/account' : Account,
    '/admin/users' : AdminUsers,
    '/login' : Login,

    '/' : AgentsProducts,
    '*' : AgentsProducts,
}

export default mainRoutes;
